import { WbDrawer } from '../WbDrawer';
import { MultiSelectionPickerContextProvider } from './MultiSelectionPickerContext';
import { PickerContent, WbMultiSelectionPickerProps } from './PickerContent';

export function WbMultiSelectionPickerDrawer<T>(
  props: WbMultiSelectionPickerProps<T>,
) {
  const {
    open,
    setOpen,
    selectedValues,
    setSelectedValues,
    children,
    title,
    fetchAiData,
    contentHeader,
  } = props;

  return (
    <WbDrawer
      open={open}
      setOpen={setOpen}
      title={title}
      contentContainerStyle={{
        padding: 0,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <MultiSelectionPickerContextProvider<T>
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        fetchAIData={fetchAiData}
      >
        <PickerContent contentHeader={contentHeader} {...props}>
          {children}
        </PickerContent>
      </MultiSelectionPickerContextProvider>
    </WbDrawer>
  );
}
